<template>
	<div>

		<!-- Budgets -->
		<BudgetComponentModal v-if="$store.state.budget.budgetComponentModalId" />
		<NewBudgetSelectModal v-if="$store.state.budget.modalNewBudget"/>
		<BudgetPrefixesModal v-if="$store.state.budget.newBudgetPrefixModal" />
		<BudgetTitleModal v-if="$store.state.budget.newBudgetTitleModal" />
		<BudgetConceptsModal v-if="$store.state.budget.newBudgetConceptModal" />
		<BudgetCategoryModal v-if="$store.state.budget.newBudgetCategoryModal" />
		<BudgetDetailModal v-if="$store.state.budget.newBudgetDetailModal" />
		<BudgetNoteTemplateModal v-if="$store.state.budget.newBudgetNoteTemplateModal" />
		<BudgetPdfModal v-if="$store.state.budget.budgetPdfModal"/>

		<!-- Clients -->
		<ClientDetailModal v-if="$store.state.users.clientModal"/>
		<ClientsBudgetModal v-if="$store.state.budget.budgetModalId"/>
		<ClientsReportModal v-if="$store.state.reports.reportModalId"/>
		<ClientsContractModal v-if="$store.state.contracts.contractModalId"/>
		<SubcontractContractorModal v-if="$store.state.contracts.subcontractContractorModalId"/>
		<ClientCompanyAprovalConfirmationModal v-if="$store.state.users.clientCompanyAprovalModal?.status"/>
		<ClientsContractAddendumModal v-if="$store.state.contracts.contractAddendumModalId"/>

		<!-- Company -->
		<CompanyConceptModal v-if="$store.state.companies.newCompanyConceptModal"/>
		<CompanyModal v-if="$store.state.companies.newCompanyModal"/>
		<CompanyModalFirst v-if="$store.state.companies.newCompanyModalFirst && $store.state.user.userInfo"/>
		<RoleModal v-if="$store.state.companies.newRoleModal"/>
		<ProjectTypesModal v-if="$store.state.companies.newProjectTypeModal"/>
		<ProjectDestiniesModal v-if="$store.state.companies.newDestinyModal"/>
		<CompanyUnarchiveValuesModal v-if="$store.state.companies.newUnarchiveValueModal"/>
		<ProjectTypesCategoryModal v-if="$store.state.companies.newCategoryProjectTypeModal"/>
		<CompanyTaxOptionModal v-if="$store.state.general.taxesOptionsModal" />
		<CompanyContractSectionModal v-if="$store.state.companies.companyContractConfigModal" />
		<ContractCategoryModal v-if="$store.state.contracts.modalCategory" />
		<ContractSectionModal v-if="$store.state.contracts.modalSection" />

		<!-- Contracts -->
		<CreateContractModal v-if="$store.state.contracts.modalContract" />
		<ContractComponentModal v-if="$store.state.contracts.contractComponentModalId" />
		<SubContractComponentModal v-if="$store.state.contracts.subcontractComponentModalId" />
		<ContractAddendumComponentModal v-if="$store.state.contracts.contractAddendumComponentModalId" />
		<ContractPdfModal v-if="$store.state.contracts.contractPdfModal" />
		<ContractSignModal v-if="$store.state.contracts.contractSignModal" />
		<ContractTitleModal v-if="$store.state.contracts.newContractTitleModal" />

		<!-- CostBreakdown -->
		<CostBreakdownBaseProjectModal v-if="$store.state.costbreakdown.newCostBreakdownBaseProjectModal"/>
		<CostBreakdownCategoryModal v-if="$store.state.costbreakdown.newCostBreakdownCategoryModal"/>
		<CostBreakdownSubCategoryModal v-if="$store.state.costbreakdown.newCostBreakdownSubCategoryModal"/>
		<CostBreakdownItemModal v-if="$store.state.costbreakdown.newCostBreakdownItemModal"/>
		<CostBreakdownSecondaryTables v-if="$store.state.costbreakdown.showModalProjectTables"/>
		<CostBreakdownSubpaymentConfiguration v-if="$store.state.costbreakdown.subPaymentCostBreakdownConfiguration"/>
		<CostPdfModal v-if="$store.state.costbreakdown.costPdfModal"/>

		<!-- CRM -->
		<ConversationModal v-if="$store.state.crm.crmModalId || $store.state.crm.crmModalScheduleId"/>
		<NewCrmContactModal v-if="$store.state.crm.newContactModal"/>

		<!-- General -->
		<UserBillingInfoModal v-if="$store.state.general.userTypePromptModal" />
		<AddressModal v-if="$store.state.general.addressModal" />
		<ImportantNotificationModal v-if="$store.state.general.importantNotificationModal && !$store.state.general.importantNotificationSessionShown" />
		<FileViewerModal v-if="$store.state.general.selectedFile && $store.state.general.selectedFile.to_modal" />
		<ExistentDocumentNotificationModal v-if="$store.state.general.existentDocumentNotificationModal" />
		<GeneralConfirmationModal v-if="$store.state.general.generalConfirmationModal?.status"
				:modalData="$store.state.general.generalConfirmationModal"
				:closeModal="() => $store.commit('general/setGeneralConfirmationModal', null)"/>
		<GeneralOptions v-if="$store.state.general.generalOptionsModal"/>

		<!-- Payments -->
		<ManualPaymentOrder v-if="$store.state.general.manualPaymentOrderModal?.status"/>

		<!-- PreProject -->
		<PreProjectModal v-if="$store.state.preprojects.preProjectModalId"/>
		<NewPreProjectModal v-if="$store.state.preprojects.newPreProjectModal"/>

		<!-- Projects -->
		<ProjectModal v-if="$store.state.projects.projectModal" />
		<EditProjectModal v-if="$store.state.projects.editProjectModal" />
		<ProjectPlanningConfigModal v-if="$store.state.projects.projectPlanningConfigModal" />
		<AdditionalRequirementForProject v-if="$store.state.projects.projectAdditionalRequirementInfoModal" />
		<AdditionalRequirementDetailModal v-if="$store.state.projects.additionalRequirementDetailModal" />

		<!-- Reports -->
		<ReportComponentModal
			v-for="(report_id, index) in $store.state.reports.reportComponentModalId"
			:key="'r'+index"
			:reportComponentModalId="report_id"
			/>
		<ReportPdfModal v-if="$store.state.reports.reportPdfModal"/>
		<ConfirmNewReportCreationModal v-if="$store.state.reports.confirmNewReportModal"/>
		<ReportTitleModal v-if="$store.state.reports.newReportTitleModal" />

		<!-- Schedules -->
		<ReportTemplateModal v-if="$store.state.vt.newReportTemplateModal"/>
		<Schedule v-if="$store.state.schedule.newScheduleModal"/>
		<AgendaClosure v-if="$store.state.vt.agendaClosureModal"/>

		<!-- SocialProfiles -->
		<SocialProfile v-if="$store.state.general.publicProfileModal" />

		<!-- UserRequests -->
		<NewUserRequest v-if="$store.state.userrequests.newRequestModal" />
		<UserRequestModal v-if="$store.state.userrequests.userRequestModalId" />

		<!-- Users -->
		<NewUserModal v-if="$store.state.users.newUserModal"/>
		<EditPermisosUserModal v-if="$store.state.users.editPermisosUserModal"/>
		<EditMyUserData v-if="$store.state.user.editMyUserDataModal" />
		<UserSignatureModal v-if="$store.state.users.userSignatureModal" />

	</div>
</template>

<script>
// Budgets
import BudgetComponentModal from './Budgets/BudgetComponentModal'
import BudgetCategoryModal from './Budgets/BudgetCategoryModal'
import BudgetConceptsModal from './Budgets/BudgetConceptsModal'
import BudgetDetailModal from './Budgets/BudgetDetailModal'
import BudgetNoteTemplateModal from './Budgets/BudgetNoteTemplateModal'
import BudgetPdfModal from './Budgets/BudgetPdfModal'
import BudgetPrefixesModal from './Budgets/BudgetPrefixesModal'
import BudgetTitleModal from './Budgets/BudgetTitleModal'
import NewBudgetSelectModal from './Budgets/NewBudgetSelectModal'

// Clients
import ClientCompanyAprovalConfirmationModal from './Clients/ClientCompanyAprovalConfirmationModal'
import ClientDetailModal from './Clients/ClientDetailModal'
import ClientsBudgetModal from './Clients/ClientsBudgetModal'
import ClientsContractAddendumModal from './Clients/ClientsContractAddendumModal'
import ClientsContractModal from './Clients/ClientsContractModal'
import ClientsReportModal from './Clients/ClientsReportModal'
import SubcontractContractorModal from './Clients/SubcontractContractorModal'

// Company
import CompanyConceptModal from './Company/CompanyConceptModal'
import CompanyContractSectionModal from './Company/CompanyContractSectionModal'
import CompanyModal from './Company/CompanyModal'
import CompanyModalFirst from './Company/CompanyModalFirst'
import CompanyTaxOptionModal from './Company/CompanyTaxOptionModal'
import CompanyUnarchiveValuesModal from './Company/CompanyUnarchiveValuesModal'
import ContractCategoryModal from './Company/ContractCategoryModal'
import ContractSectionModal from './Company/ContractSectionModal'
import ProjectDestiniesModal from './Company/ProjectDestiniesModal'
import ProjectTypesCategoryModal from './Company/ProjectTypesCategoryModal'
import ProjectTypesModal from './Company/ProjectTypesModal'
import RoleModal from './Company/RoleModal'

// Contracts
import ContractAddendumComponentModal from './Contracts/ContractAddendumComponentModal'
import ContractComponentModal from './Contracts/ContractComponentModal'
import ContractPdfModal from './Contracts/ContractPdfModal'
import ContractSignModal from './Contracts/ContractSignModal'
import ContractTitleModal from './Contracts/ContractTitleModal'
import CreateContractModal from './Contracts/CreateContractModal'
import SubContractComponentModal from './Contracts/SubContractComponentModal'

// CostBreakdown
import CostBreakdownBaseProjectModal from './CostBreakdown/CostBreakdownBaseProjectModal'
import CostBreakdownCategoryModal from './CostBreakdown/CostBreakdownCategoryModal'
import CostBreakdownItemModal from './CostBreakdown/CostBreakdownItemModal'
import CostBreakdownSecondaryTables from './CostBreakdown/CostBreakdownSecondaryTables'
import CostBreakdownSubCategoryModal from './CostBreakdown/CostBreakdownSubCategoryModal'
import CostBreakdownSubpaymentConfiguration from './CostBreakdown/CostBreakdownSubpaymentConfiguration'
import CostPdfModal from './CostSummary/CostPdfModal'

// CRM
import ConversationModal from './CRM/ConversationModal'
import NewCrmContactModal from './CRM/NewCrmContactModal'

// General
import AddressModal from './General/AddressModal'
import ExistentDocumentNotificationModal from './General/ExistentDocumentNotificationModal'
import FileViewerModal from './General/FileViewerModal'
import GeneralConfirmationModal from './General/GeneralConfirmationModal'
import GeneralOptions from './General/GeneralOptions'
import ImportantNotificationModal from './General/ImportantNotificationModal'
import UserBillingInfoModal from './General/UserBillingInfoModal'

// Payments
import ManualPaymentOrder from './Payments/ManualPaymentOrder'

// PreProject
import NewPreProjectModal from './PreProject/NewPreProjectModal'
import PreProjectModal from './PreProject/PreProjectModal'

// Projects
import AdditionalRequirementDetailModal from './Projects/AdditionalRequirementDetailModal'
import AdditionalRequirementForProject from './Projects/AdditionalRequirementForProject'
import EditProjectModal from './Projects/EditProjectModal'
import ProjectModal from './Projects/ProjectModal'
import ProjectPlanningConfigModal from './Projects/ProjectPlanningConfigModal'

// Reports
import ConfirmNewReportCreationModal from './Reports/ConfirmNewReportCreationModal'
import ReportComponentModal from './Reports/ReportComponentModal'
import ReportPdfModal from './Reports/ReportPdfModal'
import ReportTitleModal from './Reports/ReportTitleModal'

// Schedules
import AgendaClosure from './Schedules/AgendaClosure'
import ReportTemplateModal from './Schedules/ReportTemplateModal'
import Schedule from './Schedules/Schedule'

// SocialProfiles
import SocialProfile from './SocialProfiles/SocialProfile'

// UserRequests
import NewUserRequest from './UserRequests/NewUserRequest'
import UserRequestModal from './UserRequests/UserRequestModal'

// Users
import EditMyUserData from './Users/EditMyUserData'
import EditPermisosUserModal from './Users/EditPermisosUserModal'
import NewUserModal from './Users/NewUserModal'
import UserSignatureModal from './Users/UserSignatureModal'

export default {
	name: 'GlobalModalsIndex',
	components: {
		// Budgets
		BudgetCategoryModal,
		BudgetComponentModal,
		BudgetConceptsModal,
		BudgetDetailModal,
		BudgetNoteTemplateModal,
		BudgetPdfModal,
		BudgetPrefixesModal,
		BudgetTitleModal,
		NewBudgetSelectModal,

		// Clients
		ClientCompanyAprovalConfirmationModal,
		ClientDetailModal,
		ClientsBudgetModal,
		ClientsContractAddendumModal,
		ClientsContractModal,
		ClientsReportModal,
		SubcontractContractorModal,

		// Company
		CompanyConceptModal,
		CompanyContractSectionModal,
		CompanyModal,
		CompanyModalFirst,
		CompanyTaxOptionModal,
		CompanyUnarchiveValuesModal,
		ContractCategoryModal,
		ContractSectionModal,
		ProjectDestiniesModal,
		ProjectTypesCategoryModal,
		ProjectTypesModal,
		RoleModal,

		// Contracts
		ContractAddendumComponentModal,
		ContractComponentModal,
		ContractPdfModal,
		ContractSignModal,
		ContractTitleModal,
		CreateContractModal,
		SubContractComponentModal,

		// CostBreakdown
		CostBreakdownBaseProjectModal,
		CostBreakdownCategoryModal,
		CostBreakdownItemModal,
		CostBreakdownSecondaryTables,
		CostBreakdownSubCategoryModal,
		CostBreakdownSubpaymentConfiguration,
		CostPdfModal,

		// CRM
		ConversationModal,
		NewCrmContactModal,

		// General
		AddressModal,
		ExistentDocumentNotificationModal,
		FileViewerModal,
		GeneralConfirmationModal,
		GeneralOptions,
		ImportantNotificationModal,
		UserBillingInfoModal,

		// Payments
		ManualPaymentOrder,

		// PreProject
		NewPreProjectModal,
		PreProjectModal,

		// Projects
		AdditionalRequirementDetailModal,
		AdditionalRequirementForProject,
		EditProjectModal,
		ProjectModal,
		ProjectPlanningConfigModal,

		// Reports
		ConfirmNewReportCreationModal,
		ReportComponentModal,
		ReportPdfModal,
		ReportTitleModal,

		// Schedules
		AgendaClosure,
		ReportTemplateModal,
		Schedule,

		// SocialProfiles
		SocialProfile,

		// UserRequests
		NewUserRequest,
		UserRequestModal,

		// Users
		EditMyUserData,
		EditPermisosUserModal,
		NewUserModal,
		UserSignatureModal,
	},
	data: () => ({
		indexModal: + new Date(),
		//
	}),
	mounted(){
	}
};
</script>
<style>
	.modal-drag-custom-drag .vm--container.with-map .vm--modal{
		min-width: 900px!important;
		height: 660px!important;
	}
	/* .modal-drag-custom-drag.mobile-popup .vm--container .vm--modal{
		max-width: 100%!important;
		height: 660px!important;
	} */
	.modal-drag-custom-drag .vm--container .vm--modal{
		resize: horizontal;
		min-width: 450px;
	}
	.modal-drag-custom-drag .drag-header{
		cursor: grab;
		background: rgb(245, 245, 245);
	}
	/* .modal-drag-custom-drag .vm--modal{
		max-height: calc(90vh - 100px);
	} */
	.modal-drag-custom-drag .vm--modal .v-card__text{
		overflow-y: scroll;
		overflow-x: hidden;
		max-height: calc(90vh - 100px);
	}
	.modal-drag-custom-drag.limit-height-size .crm-conversation{
		overflow-y: scroll;
		max-height: 450px;
	}

	/* Evita el overlay de focus que cambia el color del botón al abrirse el modal */
	.v-btn:focus:not(:focus-visible)::before {
		opacity: 0 !important;
	}
</style>
